module.exports = __webpack_public_path__ + "img/bg_06.43bb972a.jpg";